export const requestSuccess = 'Request sent!';
export const requestInProgress = 'Sending request...';

export const saveRequestInProgress = 'Saving request...';
export const submitRequestInProgress = 'Submiting request...';
export const saveRequestSuccess = 'Request saved!';
export const submitRequestSuccess = 'Request submitted!';
export const requestSavedDescription = 'Request has been saved successfully!';
export const requestSuccessDescription = 'Request has been submitted successfully!';
export const requestDeleted = 'Request deleted!';
export const requestDeletedDescription = 'Request has been deleted succesfully.';

export const userError = 'Something went wrong...';
export const userErrorDescription = 'Please try again or contact the Employee Experience team if this issue persists.';
export const validationErrorOnSubmissionMsg =
  'Request has been saved as Draft. Please correct the validation errors shown on Review screen before Submission.';
